<template>
  <el-table
    :data="tableData"
    stripe
    style="width: 100%"
    height="100%"
    ref="scroll_Table"
    @mouseenter.native="autoScroll(true)"
    @mouseleave.native="autoScroll(false)"
  >
    <el-table-column prop="userName" label="姓名" align="center">
    </el-table-column>
    <el-table-column prop="workorderCode" label="工单编号" align="center">
    </el-table-column>
    <el-table-column prop="itemCode" label="物料编码" align="center">
    </el-table-column>
    <el-table-column prop="itemName" label="物料名称" align="center">
    </el-table-column>
    <el-table-column prop="quantityFeedback" label="加工件数" align="center">
    </el-table-column>
    <el-table-column prop="feedbackTime" label="报工时间" align="center">
    </el-table-column>
    <el-table-column
      prop="quantityUnquanlified"
      label="不良品数量"
      align="center"
    >
    </el-table-column>
  </el-table>
</template>
<script>
import { getFeedbackList } from '@/api/index'
export default {
  name: 'people',
  data () {
    return {
      tableData: [],
      scrolltimer: ''
    }
  },
  mounted () {
    this.getFeedbackLists()
    this.autoScroll()
  },
  beforeDestroy () {
    this.autoScroll(true)
  },
  methods: {
    // 设置自动滚动
    autoScroll (stop) {
      const table = this.$refs.scroll_Table
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer)
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop >= divData.scrollHeight) {
            // 重置table距离顶部距离
            divData.scrollTop = 0
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 100) // 滚动速度
      }
    },
    async getFeedbackLists () {
      let result = await getFeedbackList({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'tableData', result.data)
      }
    },
  }
}
</script>
